export const REMOVE_MSG = 'REMOVE_MSG'
export const ADD_MSG = 'ADD_MSG'
